// hooks/useFetch.js
//
// Generic, drop-in data-fetching hook. No axios dependency, no '/api' prefix
// assumptions — pass whatever URL your backend actually uses.
//
// Usage:
//   const { data, loading, error, refetch } = useFetch(url, { skip: false });

import { useCallback, useEffect, useRef, useState } from "react";

export default function useFetch(url, options = {}) {
    const { skip = false, fetchOptions } = options;

    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(!skip);
    const [error, setError] = useState(null);

    const fetchOptionsRef = useRef(fetchOptions);
    fetchOptionsRef.current = fetchOptions;
    
    const controllerRef = useRef(null); 

    const fetchData = useCallback(async () => {
        if (!url || skip) { setLoading(false); return; }

        controllerRef.current?.abort();
        const controller = new AbortController();
        controllerRef.current = controller;

        setLoading(true);
        setError(null);

        try {
            const res = await fetch(url, { ...fetchOptionsRef.current, signal: controller.signal });
            if (!res.ok) throw new Error(`Request failed with status ${res.status}`);
            setData(await res.json());
        } catch (err) {
            if (err.name !== "AbortError") setError(err);
        } finally {
            if (!controller.signal.aborted) setLoading(false);
        }
    }, [url, skip]);

    useEffect(() => {
        fetchData();
        return () => controllerRef.current?.abort();
    }, [fetchData]);

    // const fetchData = useCallback(async () => {
    //     if (!url || skip) {
    //         setLoading(false);
    //         return;
    //     }

    //     setLoading(true);
    //     setError(null);

    //     try {
    //         const res = await fetch(url, fetchOptionsRef.current);

    //         if (!res.ok) {
    //             throw new Error(`Request failed with status ${res.status}`);
    //         }

    //         const json = await res.json();
    //         setData(json);
    //     } catch (err) {
    //         setError(err);
    //     } finally {
    //         setLoading(false);
    //     }
    // }, [url, skip]);

    // useEffect(() => {
    //     fetchData();
    // }, [fetchData]);

    return { data, loading, error, refetch: fetchData };
}
